const appConfig = {
  // isHomepageBannerLoadLocalLottie: false,
  // openAnimation: false,
  isNewAddressPopup: true,
  homeDegradeSubPackagesList: {},
};

const module = {
  getAppConfig() {
    return appConfig;
  },
  getAppConfigForKey(key) {
    const conf = appConfig[key];
    if (conf !== undefined) {
      return conf;
    }
    return true; // 默认都true
  },
};

export default module;
